import { Divider, Form } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';

import Payment from 'components/payment';

import { articlesService, obituaryService } from 'config/services';

import { HttpError } from 'helpers/http';

import { Article } from 'types/services/articles';
import { OFormat, ObituaryInfoUuid } from 'types/services/obituary';

import { Footer } from './Footer';
import { Header } from './Header';

export const FrontViewUuid = (props?: any) => {
  const { t } = useTranslation();
  let url = new URL(window.location.href);
  let uuid = new URLSearchParams(url.search).getAll('uuid');
  const location = useLocation();
  const [signatureGenerated, setSignatureGenerated] = useState(false);
  const uuidNewPath = url.pathname.split('/');
  const uuidNew = uuidNewPath[uuidNewPath.length - 1];

  const [obituaryInfo, setObituaryInfo] = useState<ObituaryInfoUuid>({
    publishedDate: new Date(),
    personal_message: '',
    introductory_text: '',
    main_text: '',
    bereaved: '',
    note: '',
    num_of_persons: 1,
    leaveNumber: '',
    /* billId: '', */
  });

  const {
    isLoading: isLoadingByUuid,
    data: obituaryByUuid,
    refetch: refetchByUuid,
  } = useQuery<Article, HttpError>(['getByUuid', uuid], () => articlesService.getByUuid(uuidNew || ''), {
    enabled: typeof uuid !== 'undefined',
  });

  const { data: obituaryFormat } = useQuery<OFormat, HttpError>('getObituaryFormat', () =>
    obituaryService.getObituaryFormat(),
  );

  const calculatePrice = (numOfPersons: number | undefined) => {
    const targetObituaryFormat = obituaryFormat?.data.filter((o) => o.id === obituaryByUuid?.obituaryFormat.id);
    let total_price = 0;
    if (targetObituaryFormat && numOfPersons && targetObituaryFormat.length > 0)
      total_price = Number(targetObituaryFormat[0].price) + (numOfPersons - 1) * 10;
    return total_price;
  };

  const fun = () => {
    setSignatureGenerated(true);
  };

  //   useEffect(() => {
  //     if (signatureGenerated) {
  //       var x = document.getElementById('paymentMethod') as any;

  //       if (x && signatureGenerated) {
  //         x.submit();
  //       }
  //     }
  //   }, [signatureGenerated]);

  return (
    <>
      <Header></Header>
      <div className="main-container" style={{ marginBottom: '50px' }}>
        <div className="left-container">
          <div className="flex pre">
            <p className="mta">Pregled smrtovnice</p> <Divider />
          </div>
          <div className="outline">
            <div className="inner-outline singleObituary">
              <span className="innerElement">{obituaryByUuid?.personal_message}</span>
              <br></br>
              <span
                className="innerElement"
                dangerouslySetInnerHTML={{
                  __html: obituaryByUuid?.introductory_text?.replace(new RegExp('\r?\n', 'g'), '<br />') || '',
                }}
              >
                {/* {obituaryByUuid?.introductory_text} */}
              </span>
              <br></br>
              {obituaryByUuid?.people_id && obituaryByUuid?.people_id.length === 1 ? (
                <div>
                  {obituaryByUuid?.people_id[0].filename && (
                    <span className="innerElement obituaryImage">
                      {obituaryByUuid?.people_id[0].filename && (
                        <img
                          src={obituaryByUuid?.people_id[0].filename}
                          alt="1"
                          style={{ width: '87px', height: '120px' }}
                        ></img>
                      )}
                    </span>
                  )}
                  <br></br>
                  <span
                    className="innerElement fullName"
                    style={{ textTransform: 'uppercase', fontFamily: 'DM Sans', fontSize: '22px' }}
                  >
                    {obituaryByUuid?.people_id[0].firstName}{' '}
                    {obituaryByUuid?.people_id[0].additional_name
                      ? '(' + obituaryByUuid?.people_id[0].additional_name + ')'
                      : ''}{' '}
                    {obituaryByUuid?.people_id[0].lastName}
                    {obituaryByUuid?.people_id[0].maiden_name
                      ? ', ROĐ. ' + obituaryByUuid?.people_id[0].maiden_name
                      : ''}
                  </span>
                  {/* {obituaryByUuid?.people_id[0].city && (
                    <span className="city">{obituaryByUuid?.people_id[0].city}</span>
                  )} */}
                  <br></br>
                  <span className="innerElement obituaryDate">
                    {obituaryByUuid?.people_id[0].birth_date
                      ? moment(String(obituaryByUuid?.people_id[0].birth_date)).format('DD.MM.YY')
                      : obituaryByUuid?.people_id[0].birth_approx}
                    {(obituaryByUuid?.people_id[0].birth_date ||
                      obituaryByUuid?.people_id[0].birth_end ||
                      obituaryByUuid?.people_id[0].birth_approx ||
                      obituaryByUuid?.people_id[0].birth_end_approx) &&
                      ' - '}
                    {obituaryByUuid?.people_id[0].birth_end
                      ? moment(String(obituaryByUuid?.people_id[0].birth_end)).format('DD.MM.YY')
                      : obituaryByUuid?.people_id[0].birth_end_approx}
                  </span>
                </div>
              ) : obituaryByUuid?.people_id && obituaryByUuid?.people_id.length > 1 ? (
                <div className="obituary-wrapper">
                  {obituaryByUuid?.people_id.map((p, i) => {
                    return (
                      <div className="obituary-child">
                        {p.filename && (
                          <span className="innerElement">
                            {p.filename && (
                              <img src={p.filename} alt="1" style={{ width: '87px', height: '120px' }}></img>
                            )}
                          </span>
                        )}
                        <br></br>
                        <span className="innerElement fullName">
                          {p.firstName} {p.additional_name ? '(' + p.additional_name + ')' : ''} {p.lastName}{' '}
                          {p.maiden_name ? ', ROĐ. ' + p.maiden_name : ''}
                        </span>
                        {/* {p.city && <span className="city">{p.city}</span>} */}
                        <span className="innerElement bottom-date obituaryDate">
                          {p.birth_date ? moment(String(p.birth_date)).format('DD.MM.YY') : p.birth_approx}
                          {(p.birth_date || p.birth_end || p.birth_approx || p.birth_end_approx) && ' - '}
                          {p.birth_end ? moment(String(p.birth_end)).format('DD.MM.YY') : p.birth_end_approx}
                        </span>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <></>
              )}
              <br></br>
              <span
                className="innerElement obituatyMainText"
                dangerouslySetInnerHTML={{
                  __html: obituaryByUuid?.main_text?.replace(new RegExp('\r?\n', 'g'), '<br />') || '',
                }}
              >
                {/* {obituaryByUuid?.main_text} */}
              </span>
              <span style={{ marginTop: '20px' }} className="innerElement obituaryBereaved">
                {obituaryByUuid?.bereaved}
              </span>
            </div>
          </div>
        </div>
        <div className="right-container">
          <div className="flex">
            <p className="mta">Cijena</p> <Divider />
          </div>
          <div>
            <div className="">
              <Form.Item label={t('article:Publication date')} name="dateOfPublish" className="flex f-direction">
                <span className="fright">
                  {moment(String(obituaryByUuid?.published_date)).format('DD.MM.YY')}
                  {/* {moment(String(form.getFieldValue('publicationTime'))).format('DD.MM.YY')} */}
                </span>
              </Form.Item>

              <Form.Item label={t('article:totalToPay')} name="totalToPay" className="flex f-direction">
                <span className="fright">{calculatePrice(obituaryByUuid?.num_of_persons)} KM</span>
              </Form.Item>
              <Divider></Divider>
              <span>
                <b>Napomene:</b> Dnevni avaz vikendom izlazi kao dvobroj.
                <br />
                <br /> Molimo Vas da smrtovnice uplatite do 17:00, ukoliko želite da iste budu objavljene sutradan u
                printanom izdanju.
                <br />
                <br /> U cijenu je uključena objava smrtovnice na portalu.
              </span>
            </div>

            <input
              type="submit"
              form="obituaryForm"
              value={!location.pathname.includes('/obituary') ? 'Na plaćanje' : 'Odobri'}
              style={{
                height: '35px',
                width: '159px',
                background: '#12CE78',
                font: 'DM Sans',
                color: '#FFFFFF',
                textTransform: 'uppercase',
                borderRadius: '5px',
                border: 'none',
                cursor: 'pointer',
                marginTop: '18px',
              }}
              onClick={() => {
                setObituaryInfo({
                  leaveNumber: obituaryByUuid?.leaveNumber,
                  publishedDate: obituaryByUuid?.published_date,
                  personal_message: obituaryByUuid?.personal_message,
                  introductory_text: obituaryByUuid?.introductory_text,
                  main_text: obituaryByUuid?.main_text,
                  bereaved: obituaryByUuid?.bereaved,
                  note: obituaryByUuid?.note,
                  num_of_persons: obituaryByUuid?.num_of_persons,
                  /* billId: obituaryByUuid?.billId, */
                });
                if (signatureGenerated) {
                  var x = document.getElementById('paymentMethod') as any;

                  if (x && signatureGenerated) {
                    x.submit();
                  }
                }
                //TODO: provjeriti da li treba async/await ili timeout ukoliko se jedna od formi ne submita kako treba
              }}
            />
          </div>
        </div>
      </div>
      <div style={{ borderBottom: '1px solid #E3E3E3' }}></div>
      {!location.pathname.includes('/obituary') && obituaryByUuid && <Payment uuid={obituaryByUuid?.uuid} fun={fun} />}

      {/* <Button
          type="primary"
          htmlType="submit"
          className="button-bg"
          onClick={() => {
            next(2);
          }}
        >
          <IconArrow></IconArrow>
        </Button> */}
      <Footer></Footer>
    </>
  );
};
